<!-- Modal Alta Preliminar-->
<empusa-core-spinner *ngIf="spinnerSrv.loading" [overlay]="true"></empusa-core-spinner>
<div class="modal-content">

  <div class="modal-header">
    <div style="display: flex; align-items: center;">
      <h3 class="modal-title font">{{titulo}}</h3>
      <div class="tool-help" (click)="openModalAyuda()" style="cursor: pointer; margin-left:0.8em"><span>?</span></div>
    </div>
    <button type="button" (click)="closeDialog()" class="close" data-dismiss="modal" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body" style="max-height: 70vh; overflow-y: auto;">
    <!-- Formulario Alta preliminar -->
    <form class="form-modal py-3" [formGroup]="modelForm">
      <div class="d-flex content-title">
        <div class="d-flex">
          <h2 class="title-pag">Datos </h2>
          <div class="custom-container" [ngStyle]="styleEstadoAportaciones" style="font-weight: 600;">
            <div>
              <span style="font-size: larger; padding-top: 5px; display: flex;">
                <mat-icon class="show-icon" [style.color.important]="styleEstadoAportaciones?.['color']">{{iconEstado}}</mat-icon>
              </span>
            </div>
            <div>
              <span class="info-texto-estado" [style.color.important]="styleEstadoAportaciones?.['color']" style="font-weight: 600; display: block;">
                {{aportacion?.estado?.descripcion}}</span>
            </div>
            <div *ngIf="aportacion?.estado?.id === 5 && aportacion?.motivoRechazo" style="padding-top: 8px;">
              <div class="tool-help" [matTooltip]="aportacion?.motivoRechazo">
                <span>i</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row form">
        <div class="col-sm flex-grow-2">
          <label for="documentoIdentificacion">Núm. Documento de Identificación / Full de Seguiment <span class="oblig">*</span></label>
          <div class="custom-mat-field">
            <mat-form-field class="custom-mat-form-field" appearance="outline">
              <input matInput formControlName="documentoIdentificacion" id="documentoIdentificacion"
                placeholder="Núm. Documento de Identificación / Full de Seguiment" type="text" maxlength="255">
              <mat-error *ngIf="controlHasError( 'documentoIdentificacion', 'maxlength')">Máximo 255 caracteres</mat-error>
            </mat-form-field>
          </div>
        </div>
      </div>
      <div class="row form">
        <div class="col-sm flex-grow-1">
          <div style="display: flex; align-items: center;">
            <label for="fechaAceptacion">Fecha de aceptación <span class="oblig">*</span></label>
            <div class="tool-help" matTooltip="Fecha de aceptación del residuo por parte del gestor (en documento DI)"
              data-placement="top" title="">
              <span>i</span>
            </div>
          </div>
          <div class="custom-mat-field">
            <mat-form-field appearance="outline" class="custom-mat-form-field">
              <input matInput [matDatepicker]="datepicker" formControlName="fechaAceptacion">
              <mat-datepicker-toggle matIconSuffix [for]="datepicker"></mat-datepicker-toggle>
              <mat-datepicker #datepicker>
              </mat-datepicker>
              <mat-error *ngIf="controlHasError('fechaAceptacion', 'matDatepickerParse')">Formato incorrecto</mat-error>
            </mat-form-field>
          </div>
        </div>
        <div class="col-sm flex-grow-1">
          <label for="fechaAceptacion">Fecha de aportación</label>
          <div class="custom-mat-field">
            <mat-form-field appearance="outline" class="custom-mat-form-field">
              <input matInput [matDatepicker]="datepicker2" formControlName="fechaAportacion">
              <mat-datepicker-toggle matIconSuffix [for]="datepicker2"></mat-datepicker-toggle>
              <mat-datepicker #datepicker2>
              </mat-datepicker>
            </mat-form-field>
          </div>
        </div>
        <div class="col-sm flex-grow-1" *ngIf="false">
          <label for="estado">Estado </label>
          <div class="custom-mat-field">
            <mat-form-field class="custom-mat-form-field" appearance="outline">
              <mat-select formControlName="estado" id="estado" placeholder="-- Estado --">
                <mat-option *ngFor="let des of estadoArray" [value]="des" [disabled]="this.edicion">
                  {{ des.descripcion }}
                </mat-option>
              </mat-select>
              <span *ngIf="showClearButton('estado') && !this.edicion" tabindex="0" class="ng-clear-wrapper"
                (click)="clearSelection($event,'estado')">
                <span aria-hidden="true" class="ng-clear">×</span>
              </span>
            </mat-form-field>
          </div>
        </div>
      </div>
        <!--<div class="row form" >
          <div class="col-sm flex-grow-1">
            <div style="display: flex; align-items: center;">
              <label for="idSolicitud">ID. Solicitud Retirada <span class="oblig">*</span></label>
              <div class="tool-help"
                   matTooltip="Haga clic en la lupa para cargar la solicitud de retirada con el identificador proporcionado"
                   data-placement="top" title="">
                <span>i</span>
              </div>
            </div>
            <div class="custom-mat-field">
              <mat-form-field class="custom-mat-form-field" appearance="outline">
                <input matInput formControlName="idSolicitud" id="idSolicitud"
                       type="text" maxlength="10"
                       placeholder="Pulse en la lupa para buscar"
                       (keydown)="onlyNumberKey($event)">
                <mat-error *ngIf="controlHasError( 'idSolicitud', 'maxlength')">Máximo 10 caracteres
                </mat-error>
              </mat-form-field>
            </div>
          </div>
          <div class="col-sm flex-grow-0" *ngIf="this.canSaveAll()" style="padding-top: 3px;">
            <button type="button" class="btn btn-outline-primary" data-dismiss="modal"
                    (click)="buscarSolicitudRetirada()" aria-label="buscar por Identificador"
                    style="margin-top:25px"><span>
                            <mat-icon>search</mat-icon>
                        </span></button>
          </div>
          <div class="col-sm flex-grow-1">
            <div style="display: flex; align-items: center;">
              <label for="usuarioSddrCa">Usuario SDDR Abierto <span class="oblig">*</span></label>
              <div class="tool-help"
                   matTooltip="El Usuario SDDR Abierto se cargará automáticamente al introducir el ID de la Solicitud de Retirada, si está asignada a alguno de sus gestores"
                   data-placement="top" title="">
                <span>i</span>
              </div>
            </div>
            <div class="custom-mat-field">
              <mat-form-field class="custom-mat-form-field" appearance="outline">
                <input matInput formControlName="usuarioSddrCa" id="usuarioSddrCa"
                       placeholder="Usuario SDDR Abierto" type="text" readonly>
              </mat-form-field>
            </div>
          </div>
        </div>-->

        <div class="row form">
            <div class="col-sm flex-grow-1">
                <label for="nimaGestor">NIMA del gestor <span class="oblig">*</span></label>
                <div class="custom-mat-field">
                    <mat-form-field class="custom-mat-form-field" appearance="outline" >
                      <input matInput formControlName="nimaGestor" id="nimaGestor"
                       placeholder="-- NIMA del gestor --" type="text" maxlength="10" (input)="onInput('nimaGestor', $event)">
                    <mat-error *ngIf="controlHasError( 'nimaGestor', 'required')">Campo obligatorio</mat-error>
                    <mat-error *ngIf="controlHasError('nimaGestor', 'pattern')">Formato incorrecto</mat-error>
                    </mat-form-field>
                </div>
            </div>
            <div class="col-sm flex-grow-1">
                <label for="documentoGestor">Documento gestor (NIF) <span class="oblig">*</span></label>
                <div class="custom-mat-field">
                    <mat-form-field class="custom-mat-form-field" appearance="outline" >
                      <input matInput formControlName="documentoGestor" id="documentoGestor"
                       placeholder="-- Documento gestor (NIF) --" type="text" maxlength="15" (input)="onInput('documentoGestor', $event)" >
                     <mat-error *ngIf="controlHasError( 'documentoGestor', 'required')">Campo obligatorio </mat-error>
                     <mat-error *ngIf="controlHasError( 'documentoGestor', 'maxlength')">Máximo 15 caracteres</mat-error>
                     <mat-error *ngIf="controlHasError('documentoGestor', 'pattern')">Formato incorrecto</mat-error>
                    </mat-form-field>
                </div>
            </div>
            <div class="col-sm flex-grow-0">
              <div class="custom-mat-field">
                <div class="tool-help" matTooltip="Pulse para autocompletar"
                  data-placement="top" title="">
                  <span>i</span>
                </div>

            <div class="field field-10" >
              <span class="lupa" (click)="buscarGestor();">
                <mat-icon>search</mat-icon>
              </span>
            </div>
              </div>
            </div>
            <div class="col-sm flex-grow-1">
                <label for="razonSocialGestor">Razón social del gestor <span class="oblig">*</span></label>
                <div class="custom-mat-field">
                    <mat-form-field class="custom-mat-form-field" appearance="outline" >
                      <input matInput formControlName="razonSocialGestor" id="razonSocialGestor"
                       placeholder="-- Razón social del gestor --" type="text"  >
                     <mat-error *ngIf="controlHasError( 'razonSocialGestor', 'required')">Campo obligatorio </mat-error>
                     <mat-error *ngIf="controlHasError( 'razonSocialGestor', 'maxlength')">Máximo 255 caracteres</mat-error>
                    </mat-form-field>
                </div>
            </div>
        </div>

        <div class="row form">
            <div class="col-sm flex-grow-1">
                <label for="nimaAcondicionador">NIMA del acondicionador <span class="oblig">*</span></label>
                <div class="custom-mat-field">
                    <mat-form-field class="custom-mat-form-field" appearance="outline" >
                      <input matInput formControlName="nimaRazonAcondicionador" id="nimaRazonAcondicionador"
                       placeholder="-- NIMA del acondicionador --" type="text" readonly>
                    </mat-form-field>
                </div>
            </div>
        </div>
        
        <div class="row form">
        <div class="col-sm flex-grow-1">
          <div style="display: flex; align-items: center;">
            <label for="codigoLer">Código LER y descripción de ENVALORA <span class="oblig">* </span><em
                *ngIf="modelForm.get('codigoLer')?.value?.peligrosidad === true" class="fas fa-skull-crossbones"
                style="color: #B80F61;" matTooltip="Envase de tipo peligroso"></em></label>
          </div>
          <div class="custom-mat-form-field">
            <mat-form-field class="custom-mat-form-field" appearance="outline">
              <mat-select formControlName="codigoLer" id="codigoLer" placeholder="Código LER y descripción de ENVALORA">
                <mat-option *ngFor="let cod of codigoLerArray" [value]="cod"
                  [disabled]="!canAccessEditEstado() || (!canViewResource('PO-GESTOR') && !canViewResource('PO-POSEEDOR'))">
                  {{ cod.tipoCodigo }} {{ cod.descripcion }}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="controlHasError('codigoLer', 'required')">Campo obligatorio</mat-error>
            </mat-form-field>
          </div>
        </div>
      </div>
      <div class="row form">
        <div class="col-sm-6 flex-grow-1" style="max-width: 50%;">
          <div style="display: flex; align-items: center;">
            <label for="operacionGestion">Operación de gestión específica <span class="oblig">*</span></label>
            <div class="tool-help"
              matTooltip="Puede comprobar la operación de gestión en el DI facilitado por su gestor. En caso de duda, consulte con su gestor sobre la operación de gestión específica"
              data-placement="top" title="">
              <span>i</span>
            </div>
          </div>
          <div class="custom-mat-field" style="width: 100%; overflow: hidden;">
            <ng-container *ngIf="modelForm.get('codigoLer')?.value; else operacionGestionDisabled">
              <lib-ge-select-pagination [endPointFilter]="operacionGestionEndpoint" [multiple]=false [updateList]="updateList"
                [placeHolder]="'-- Operación de gestión específica --'" [formControlNameSelect]="getFormControl('operacionGestion')"
                [descripcion]="getOperacionesGestionDescription" [objQueryName]="getOperacionesGestionObjectQuery" [defaultParameters]="defaultOperacionesGestionParameters">
              </lib-ge-select-pagination>
            </ng-container>
            <ng-template #operacionGestionDisabled>
              <mat-form-field class="custom-mat-form-field" appearance="outline">
                <mat-select formControlName="operacionGestion" id="operacionGestion"
                  placeholder="-- Operación de gestión específica --">
                </mat-select>
                <mat-error *ngIf="controlHasError('operacionGestion', 'required')">Campo obligatorio</mat-error>
              </mat-form-field>
            </ng-template>
          </div>
        </div>
        <div class="col-sm-6 flex-grow-1" style="max-width: 50%;">
          <label for="cantidadGestionada">Cantidad neta gestionada (Kg) <span class="oblig">*</span></label>
          <div class="custom-mat-field">
            <mat-form-field class="custom-mat-form-field" appearance="outline">
              <input matInput formControlName="cantidadGestionada" id="cantidadGestionada"
                placeholder="Cantidad neta gestionada (Kg)" type="number" [min]="0" DirectDecimalNumber>
              <mat-error *ngIf="controlHasError('cantidadGestionada', 'min')">El valor debe ser superior a 0</mat-error>
            </mat-form-field>
          </div>
        </div>
      </div>
      <div class="row form">
        <div class="col-sm flex-grow-1">
          <label for="documento">Documento <span class="oblig">*</span></label>
          <div class="custom-mat-field">
            <div class="attach">
              <div *ngIf="canSaveAll()">
                <input #file type="file" (change)="file && file.files && attachAdjunto(file.files[0])" class="hide"
                  id="adjuntar" name="adjuntar">
                <mat-icon (click)="file.click()" class="ml-2 color-custom pointer-cursor"
                  matTooltip="Adjuntar documento">upload_file</mat-icon>
              </div>
              <div>
                <div fxLayout="row" fxLayoutAlign="space-between center" *ngIf="documento != undefined"
                  class="centrar archivo">
                  <div><span class="sprite-icon ico-adjuntar"></span><span class="nombre-archivo">{{documento.name}}
                    </span>
                  </div>
                </div>
                <div fxLayout="row" fxLayoutAlign="space-between center"
                  *ngIf="(this.aportacion?.documento != undefined && documento === undefined)" class="centrar archivo">
                  <div><span class="sprite-icon ico-adjuntar"></span><span
                      class="nombre-archivo">{{this.aportacion.documento!.nombre}}
                    </span>
                    <mat-icon (click)="descargar(this.aportacion.documento)" class="ml-2 color-custom pointer-cursor"
                      matTooltip="Descargar">
                      download</mat-icon>
                    <mat-icon (click)="vistaPreviaAportacion(this.aportacion.documento)" class="ml-2 color-custom pointer-cursor" style="margin-left: 0.3em;"
                      matTooltip="Vista previa">
                      preview
                    </mat-icon>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm flex-grow-1">
          <label for="autofactura">Prefactura</label>
          <div fxLayout="row" fxLayoutAlign="space-between center"
            *ngIf="(this.aportacion?.facturaGestor?.documentoAutofactura != undefined)" class="centrar archivo">
            <div><span class="sprite-icon ico-adjuntar"></span>
              <span
                class="nombre-archivo">{{this.aportacion?.facturaGestor?.documentoAutofactura?.nombre}}
              </span>
              <mat-icon (click)="descargar(this.aportacion?.facturaGestor?.documentoAutofactura)" matTooltip="Descargar"
                class="ml-2 color-custom pointer-cursor">
                download</mat-icon>
            </div>
          </div>
          <div fxLayout="row" fxLayoutAlign="space-between center"
            *ngIf="(this.aportacion?.facturaPoseedor?.documentoAutofactura != undefined)" class="centrar archivo">
            <div><span class="sprite-icon ico-adjuntar"></span>
              <span
                class="nombre-archivo">{{this.aportacion?.facturaPoseedor?.documentoAutofactura?.nombre}}
              </span>
              <mat-icon (click)="descargar(this.aportacion?.facturaPoseedor?.documentoAutofactura)" matTooltip="Descargar"
                class="ml-2 color-custom pointer-cursor">
                download</mat-icon>
            </div>
          </div>
        </div>
      </div>

    </form>
    <!-- FIN Formulario de Alta preliminar -->
  </div>

  <div class="fixed-footer">
    <div class="modal-footer actions">
      <div class="note">* Campos Obligatorios</div>
      <div class="button-group">
        <button type="button" (click)="closeDialog()" class="btn btn-outline-primary" data-dismiss="modal"
          aria-label="Close">Volver</button>
        <button *ngIf="canSaveAll() && edicion" type="button" class="btn btn-primary" data-dismiss="modal" aria-label="Close"
          (click)="buttonSaveData(null)">Guardar</button>
        <button *ngIf="canSaveAll()" type="button" class="btn btn-primary" data-dismiss="modal" aria-label="Close"
          (click)="buttonSaveData(2)">Guardar y
          Finalizar</button>
        <button *ngIf="canAccessAcceptAportacion()" type="button" class="btn btn-primary" data-dismiss="modal" aria-label="Close"
          (click)="acceptAportacion()">Aceptar DI/FS</button>
        <button *ngIf="canAccessCancelAportacion()" type="button" class="btn btn-primary" data-dismiss="modal" aria-label="Close"
          (click)="openModalMotivoCancelAportacion()">Cancelar DI/FS</button>
      </div>
    </div>
  </div>

</div>